import { fetchmealPlanSummary } from "../../api/mealPlanSummaryApi";
import * as Endpoints from "../../entities/Endpoints";

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const fetchMealPlanSummaryThunk = createAsyncThunk(
  Endpoints.FETCH_MEAL_PLAN_SUMMARY,
  async ({ coachId, recipeIds, mealType }, { rejectWithValue }) => {
    try {
      const data = await fetchmealPlanSummary({ coachId, recipeIds, mealType });
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const mealPlanSummarySlice = createSlice({
  name: "getMealPlanSUmmary",
  initialState: {
    mealPlanSummary: null,
    isloading: false,
    error: null,
    successMessage: null,
    updateSuccessMessage: "",
    updateFailedMessage: "",
  },
  reducers: {
    clearUpdateMessage: (state) => {
      state.updateSuccessMessage = "";
      state.updateFailedMessage = "";
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchMealPlanSummaryThunk.pending, (state) => {
        state.isloading = true;
        state.error = null;
        state.updateSuccessMessage = "";
        state.updateFailedMessage = "";
      })
      .addCase(fetchMealPlanSummaryThunk.fulfilled, (state, action) => {
        state.isloading = false;
        state.mealPlanSummary = action.payload;
      })
      .addCase(fetchMealPlanSummaryThunk.rejected, (state, action) => {
        state.isloading = false;
        state.error = action.payload;
        state.updateFailedMessage = action.payload;
      });
  },
});
export const { clearUpdateMessage } = mealPlanSummarySlice.actions;
export const mealPlanSummaryReducer = mealPlanSummarySlice.reducer;
